import { Fragment, useState, useEffect, useRef } from "react";
// import axios from "axios";
import { useTranslation } from 'react-i18next';
// import numeral from 'numeral';
import mergeImages from 'merge-images';

// import Backdrop from "../Backdrop/Backdrop";
// import CombinerInfo from "./CombinerInfo";
// import CombinerFileSelectContents from "./CombinerFileSelectContents";
// import CombinerFileEdit from "./CombinerFileEdit";
// import ImageConvert from "../ImageConvert/ImageConvert";
// import Modal from "../Modal/Modal";

import { useStore } from '../../hook-store/store';
// import { changeImageDimensionSize } from '../../utils/image-util'

// import { BACKEND_URL } from "../../App";

import { marks } from '../../utils/marks';
import "./ImageMerger.css";
import "./MergerSettings.css";

import CustomExplainImage from '../../images/imageMerger/image-for-merger-custom-crop-h250.jpg';

import HrDirectionImage from '../../images/imageMerger/image-for-merger-hr-h100.jpg';
import VrDirectionImage from '../../images/imageMerger/image-for-merger-vr-h100.jpg';



export default function MergerSettings(props) {
  const { 
    inputFiles,
    setInputFiles,
    fileDimensions,
    setFileDimensions,
    mergedFile,
    setMergedFile,
  } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { 
    // isAuth, 
    gLoading 
  } = store.uiStore;


  const [mergedImageSrc, setMergedImageSrc] = useState('');
  const [mergeDirection, setMergeDirection] = useState('hr'); //// 'hr', 'vr'
  const [showCustomPosition, setShowCustomPosition] = useState(false);

  const [customPosition, setCustomPosition] = useState({
    image1x: 0, 
    image1y: 0, 
    image2x: 0, 
    image2y: 0,
  });
  const [totalDimension, setTotalDimension] = useState({
    width: 0,
    height: 0,
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (gLoading) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  },[gLoading]);

  useEffect(() => {
    if (fileDimensions.length > 1) {
      setTotalDimensionHandler(fileDimensions, customPosition);
    }
  },[customPosition]);

  useEffect(() => {
    setCustomPosition({
      image1x: 0, 
      image1y: 0, 
      image2x: 0, 
      image2y: 0,
    });
    setMergeDirection('hr');
    setShowCustomPosition(false);
    // setTotalDimension({
    //   width: 0,
    //   height: 0,
    // });
  },[inputFiles, fileDimensions]);

  // useEffect(() => {
  //   mergeFileHandler(inputFiles, fileDimensions, mergeDirection);
  // }, [inputFiles, fileDimensions, mergeDirection]);


  const mergeFileHandler = async (inputFiles, fileDimensions, mergeDirection) => {
        // The mergeImages function accepts an array of image sources
    // Sources can be file paths, URLs, or data URIs
    try {
      if (inputFiles.length > 1) {

        let mOne = { 
          src: URL.createObjectURL(inputFiles[0]), 
          x: 0, 
          y: 0 
        };

        let mTwo = { 
          src: URL.createObjectURL(inputFiles[1]), 
          x: 0, 
          y: fileDimensions[0].height 
        };

        let mOptions = {
          height: fileDimensions[0].height + fileDimensions[1].height,
        }

        if (mergeDirection === 'hr') {
          mOne = { 
            src: URL.createObjectURL(inputFiles[0]), 
            x: 0, 
            y: 0,
          };

          mTwo = { 
            src: URL.createObjectURL(inputFiles[1]), 
            x: fileDimensions[0].width, 
            y: 0,
          };
          
          mOptions = {
            width:  fileDimensions[0].width + fileDimensions[1].width,
          }
        }

        if (!mergeDirection) {
          mOne = { 
            src: URL.createObjectURL(inputFiles[0]), 
            x: customPosition.image1x, 
            y: customPosition.image1y,
          };

          mTwo = { 
            src: URL.createObjectURL(inputFiles[1]), 
            x: customPosition.image2x, 
            y: customPosition.image2y,
          };
          
          mOptions = {
            width: totalDimension.width,
            height: totalDimension.height,
          }
        }

        const mergedImageB64 = await mergeImages([
          // { src: bodySrc, x: 0, y: 0 },
          // { src: eyesSrc, x: 32, y: 0 }, // Example of custom positioning
          // { src: mouthSrc, x: 16, y: 0 }
            mOne,
            mTwo,
          ],
          mOptions
        )

        if (mergedImageB64) {
          setMergedImageSrc(mergedImageB64);

          const fileData = mergedImageB64.split(";")[0];
          const fileType = fileData.split(":")[1];
          const fileName = `merged-${Date.now()}.${fileType.split("/")[1]}`;

          const result = await fetch(mergedImageB64);
          const resData = await result.blob();
          const file = new File([resData], fileName, { type: fileType });
        //   console.log(file);

          if (file) {
            setMergedFile(file);
          }
        }
  
      } 
    } catch(err) {
        console.log(err);
    }
  };

  const setCustomPositionHandler = (key, value) => {
    
    if (parseInt(value) >= 0) {
      const updatedPosition = {
        ...customPosition,
        [`${key}`]: parseInt(value),
      };
      
      // console.log(updatedPosition);
      setCustomPosition(updatedPosition);
      setMergeDirection('');
    }
  };

  const setTotalDimensionHandler = (fileDimensions, customPosition) => {
    let totalWidth = 0;
    let totalHeight = 0;

    const image1RightX = customPosition.image1x + fileDimensions[0].width;
    const image1BottomY = customPosition.image1y + fileDimensions[0].height;
    const image2RightX = customPosition.image2x + fileDimensions[1].width;
    const image2BottomY = customPosition.image2y + fileDimensions[1].height;

    if (image1RightX > image2RightX) {
      totalWidth = image1RightX;
    } else {
      totalWidth = image2RightX;
    }

    if (image1BottomY > image2BottomY) {
      totalHeight = image1BottomY;
    } else {
      totalHeight = image2BottomY;
    }

    setTotalDimension({
      width: totalWidth,
      height: totalHeight,
    });
  }


  let mergerSettingsBody;

  mergerSettingsBody = (
    <div>
      <div className="mergerSectoin">
        <strong>
          {t('imageMerger09', 'Select image direction')}
        </strong>
      </div>

      <div className="mergerSectoin">
        <div className="mergerSettingsDirections">
          <span
            onClick={() => {
              setMergeDirection('hr');
              setShowCustomPosition(false);
            }}
          >
            <div className="mergerSettingsDirectionsItem">
              <strong>
                {t('imageMerger11', 'Horizontial')}
              </strong>
              <img 
                src={HrDirectionImage}
              />
            </div>
          </span>

          <span
            onClick={() => {
              setMergeDirection('vr');
              setShowCustomPosition(false);
            }}
          >
            <div className="mergerSettingsDirectionsItem">
              <strong>
                {t('imageMerger12', 'Vertical')}
              </strong>
              <img 
                src={VrDirectionImage}
              />
            </div>
          </span>
        </div>
      </div>


      <div className="mergerSectoin">
        {t('imageMerger10', 'Selected direction')}
        {' '}
        {mergeDirection === 'hr' && (
          <strong>
            {t('imageMerger11', 'Horizontial')}
          </strong>
        )}
        {mergeDirection === 'vr' && (
          <strong>
            {t('imageMerger12', 'Vertical')}
          </strong>
        )}
        {/* merge-direction: {mergeDirection} */}
      </div>
      
      <div className="mergerSectoin">
        <span
          onClick={() => {
            setShowCustomPosition(!showCustomPosition);
            setMergeDirection('');
          }}
        >
          {t('imageMerger13', 'or, set image positions')} {marks.triangleDown}
        </span>
      </div>

      {showCustomPosition && (
        <div>
          <div className="mergerSectoin">
            <div>
              <strong>
                Image 1 Top-Left
              </strong>
                </div>
            <div className="mergerSettingsDirections">
              <div>
                <label>x</label>
                <div>
                  <input className="inputBase"
                    style={{width: "5rem"}}
                    type='text'
                    onChange={(event) => {
                      setCustomPositionHandler('image1x', event.target.value);
                    }}
                  />
                </div>
              </div>
              <div>
                <label>y</label>
                <div>
                  <input className="inputBase"
                    style={{width: "5rem"}}
                    type='text'
                    onChange={(event) => {
                      setCustomPositionHandler('image1y', event.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div>
              Image 1 Top-Left (x,y): ({customPosition.image1x}, {customPosition.image1y})
            </div>
          </div>
          
          <div className="mergerSectoin">
            <div>
              <strong>
                Image 2 Top-Left
              </strong>
            </div>
            <div className="mergerSettingsDirections">
              <div>
                <label>x</label>
                <div>
                  <input className="inputBase"
                    style={{width: "5rem"}}
                    type='text'
                    onChange={(event) => {
                      setCustomPositionHandler('image2x', event.target.value);
                    }}
                  />
                </div>
              </div>
              <div>
                <label>y</label>
                <div>
                  <input className="inputBase"
                    style={{width: "5rem"}}
                    type='text'
                    onChange={(event) => {
                      setCustomPositionHandler('image2y', event.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div>
              Image 2 Top-Left (x,y): ({customPosition.image2x}, {customPosition.image2y})
            </div>
          </div>

          <div className="mergerSectoin">
            {t('imageMerger14', 'Merged image size')} 
            {' '}
            ({t('imageMerger07', 'Width')}, {t('imageMerger08', 'Height')}): 
            {' '}
            ({totalDimension.width}, {totalDimension.height})
            {/* merged-width-height: {JSON.stringify(totalDimension)} */}
          </div>

          <div>
            <div className="mergerSectoin">
              {t('imageMerger15', 'User need to set Top-Left of image 1 and image 2.')}
              <br/>
              {t('imageMerger16', 'Top-Left of merged image is (x=0, y=0).')}
              <br/>
              {t('imageMerger17', 'Bottom-Right of merged image is width and height of merged image.')}
            </div>
            <div className="mergerSectoin">
              <img 
                className="mergerCustomExplainImage"
                src={CustomExplainImage}
              />
            </div>
          </div>
        </div>
      )}


      <div className="combinerSectoin">
        <button
          className="btnBase"
          style={{ padding: "1rem", fontWeight: "bold", fontSize: "1.25rem"}}
          disabled={inputFiles.length < 2}
          onClick={() => {
            mergeFileHandler(
              inputFiles, 
              fileDimensions, 
              mergeDirection
            );
          }}
        >
          {t('imageMerger18', 'Merge images')}
        </button>
      </div>

    </div>
  );

  return (
    <Fragment>
      <div>
        {mergerSettingsBody}
      </div>
    </Fragment>
  );
}
